import type { IconNode } from '../types';

/**
 * @name cat-big
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtNiA3IC41LjUiIC8+CiAgPHBhdGggZD0ibTE4IDctLjUuNSIgLz4KICA8cGF0aCBkPSJNNSAxM2E1IDUgMCAxIDAgNi44IDcuMmwzLTMuNkExIDEgMCAwIDAgMTQgMTVoLTRhMSAxIDAgMCAwLS44IDEuNmwzIDMuNkE1IDUgMCAxIDAgMTkgMTNoM2MwLTEuMi0uNC0yLjQtMS0zLjRhMyAzIDAgMCAwLTUuOC01LjNsLTEgMWE3IDQgMCAwIDAtNC40IDBsLTEtMUEzIDMgMCAwIDAgMyA5LjZjLS42IDEtMSAyLjItMSAzLjRaIiAvPgogIDxwYXRoIGQ9Ik0xMCAxMXYtLjUiIC8+CiAgPHBhdGggZD0iTTE0IDExdi0uNSIgLz4KICA8cGF0aCBkPSJNNSAxOEgyIiAvPgogIDxwYXRoIGQ9Ik0xOSAxOGgzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/cat-big
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const catBig: IconNode = [
  ['path', { d: 'm6 7 .5.5', key: '1mues1' }],
  ['path', { d: 'm18 7-.5.5', key: '1hegvp' }],
  [
    'path',
    {
      d: 'M5 13a5 5 0 1 0 6.8 7.2l3-3.6A1 1 0 0 0 14 15h-4a1 1 0 0 0-.8 1.6l3 3.6A5 5 0 1 0 19 13h3c0-1.2-.4-2.4-1-3.4a3 3 0 0 0-5.8-5.3l-1 1a7 4 0 0 0-4.4 0l-1-1A3 3 0 0 0 3 9.6c-.6 1-1 2.2-1 3.4Z',
      key: '71dbpf',
    },
  ],
  ['path', { d: 'M10 11v-.5', key: '14ipi' }],
  ['path', { d: 'M14 11v-.5', key: '1jad2q' }],
  ['path', { d: 'M5 18H2', key: '1mfvjg' }],
  ['path', { d: 'M19 18h3', key: 'nnkd4d' }],
];

export default catBig;
